import { createFileRoute } from "@tanstack/react-router";
import { DamageDetailPage } from "@/components/inventory/DamageDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/damages_/$id")({
  component: DamageDetailRoute,
});

function DamageDetailRoute() {
  const { id } = Route.useParams();
  return <DamageDetailPage damageId={id} />;
}
